export default "__VITE_ASSET__BpI5nXGX__";